<div #fileListExplorer class="file-list-explorer-wrapper">
    <rappider-file-explorer-with-selected-list [activeEntityData]="activeEntityData"
                                               [listGridConfig]="listGridConfig"
                                               [editFormConfig]="fileListEditFormConfig"
                                               [selectedItem]="selectedItem"
                                               [loading]="loading"
                                               [submitButtonLoading]="submitButtonLoading"
                                               [buttonConfig]="fileListButton"
                                               [selectedButtonConfig]="selectedFileListButton"
                                               [alertConfig]="fileListInfoAlertConfig"
                                               [selectedFileListInfoAlertConfig]="selectedFileListInfoAlertConfig"
                                               [folderOrder]="folderOrder"
                                               [isFileListStatic]="isFileListStatic"
                                               [selectedData]="selectedList"
                                               [selectedListEditFormVisible]="selectedListEditFormVisible"
                                               (searchTextChange)="onSearchTextChange($event)"
                                               (rowActionClick)="onRowActionClick($event)"
                                               (overflowlistItemClick)="onOverflowlistItemClick($event)"
                                               (selectList)="onSelectList($event)"
                                               (selectedList)="onSelectedList($event)"
                                               (formValueChange)="onFormValueChange($event)"
                                               (buttonClick)="onFileListButtonClick($event)"></rappider-file-explorer-with-selected-list>
</div>
